module.exports = __webpack_public_path__ + "img/coin_r.6bcefead.png";